import { AiTemplateDTO } from "../../utils/types/AiTypes";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_AI_TEMPLATE_LIST_ENDPOINT } from "../../utils/constants";

export interface AiTemplateState {
  aiTemplates: AiTemplateDTO[];
  currentPage: number;
  pageSize: number;
  totalPage: number;
  totalElements: number;
  status: "fulfilled" | "pending" | "rejected" | "idle";
}

interface AiTemplateListPagination {
  data: AiTemplateDTO[];
  currentPage: number;
  totalPage: number;
  totalElements: number;
}

const initialState: AiTemplateState = {
  aiTemplates: [],
  currentPage: 1,
  pageSize: 10,
  totalPage: 1,
  totalElements: 0,
  status: "idle",
};

export const fetchAiTemplatesByModelTypeAndGenre = createAsyncThunk(
  "aiTemplate/fetchAiTemplatesByModelTypeAndGenre",
  async (params: {
    keycloak: Keycloak.KeycloakInstance;
    modelType?: string;
    genre?: string;
    published?: boolean | undefined;
    page: number;
    size: number;
  }): Promise<AiTemplateListPagination> => {
    const { keycloak, modelType, genre, published, page, size } = params;
    const res = await axios.get(`${API_AI_TEMPLATE_LIST_ENDPOINT}`, {
      params: {
        modelType: modelType,
        genre: genre,
        published: published,
        page: page,
        size: size,
      },
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${keycloak?.token}`,
      },
      withCredentials: true,
    });
    return res.data;
  },
);

export const AiTemplateSlice = createSlice({
  name: "aiTemplates",
  initialState,
  reducers: {
    getAiTemplates: (state, action) => {
      state.status = "fulfilled";
      state.aiTemplates = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPage = action.payload.totalPage;
    },
    failedToGetAiTemplates: (state) => {
      state.status = "rejected";
      state = initialState;
    },
    resetAiTemplatesState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchAiTemplatesByModelTypeAndGenre.fulfilled,
      (state, action) => {
        state.status = "fulfilled";
        state.aiTemplates = action.payload.data;
        state.currentPage = action.payload.currentPage;
        state.totalPage = action.payload.totalPage;
        state.totalElements = action.payload.totalElements;
      },
    );
  },
});

export const { getAiTemplates, failedToGetAiTemplates, resetAiTemplatesState } =
  AiTemplateSlice.actions;
export default AiTemplateSlice.reducer;
